import React from "react";
import { PlusIcon } from '@heroicons/react/solid'

const AddUserButton = ({ setIsOpen, setUserData, setModalTitle, buttonText, setIsPreview }) => {

    function handleAddUser() {
        setIsOpen(true);

        setUserData({});
        setModalTitle(buttonText);
        { setIsPreview && setIsPreview(false); }
    }

    return (
        <button className="button with-icon -rotate bg-secondaryGradient" onClick={handleAddUser}>{buttonText} <PlusIcon /></button>
    )

};

export default AddUserButton;
